import { startCase } from "lodash";

export const REQUIRED_PRODUCT_CATEGORIES = [
  {
    key: "forex",
    label: "Forex",
  },
  {
    key: "major",
    label: "Major",
  },
  {
    key: "minor",
    label: "Minor",
  },
  {
    key: "exotic",
    label: "Exotic",
  },
  {
    key: "usIndices",
    label: "US Indices",
  },
  {
    key: "nonUsIndices",
    label: "Non-US Indices",
  },
  {
    key: "crypto1",
    label: "Crypto 1",
  },
  {
    key: "crypto2",
    label: "Crypto 2",
  },
  {
    key: "crypto3",
    label: "Crypto 3",
  },
  {
    key: "crypto4",
    label: "Crypto 4",
  },
  {
    key: "xau",
    label: "XAU",
  },
  {
    key: "xag",
    label: "XAG",
  },
];

const REQUIRED_PRODUCT_CATEGORY_KEYS = REQUIRED_PRODUCT_CATEGORIES.map(({ key }) => key);
const PRODUCT_CATEGORY_LABELS = REQUIRED_PRODUCT_CATEGORIES.reduce((acc, { key, label }) => {
  acc[key] = label;
  return acc;
}, {});

const unique = (items) => Array.from(new Set((items || []).filter(Boolean)));

export const getProductCategoryLabel = (key) => PRODUCT_CATEGORY_LABELS[key] || startCase(key);

export const normalizeProductCategories = (products = {}) => {
  const existingProducts = products && typeof products === "object" && !Array.isArray(products)
    ? products
    : {};

  const normalizedProducts = REQUIRED_PRODUCT_CATEGORIES.reduce((acc, { key }) => {
    acc[key] = Array.isArray(existingProducts[key]) ? existingProducts[key] : [];
    return acc;
  }, {});

  Object.keys(existingProducts).forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(normalizedProducts, key)) {
      normalizedProducts[key] = Array.isArray(existingProducts[key]) ? existingProducts[key] : [];
    }
  });

  return normalizedProducts;
};

export const getProductCategoryKeys = (products = {}) => Object.keys(normalizeProductCategories(products));

export const mergeIbProductCategories = (ibProducts = [], dictionaryProducts = {}) => {
  const ibProductKeys = Array.isArray(ibProducts) ? ibProducts : Object.keys(ibProducts || {});
  return unique([
    ...REQUIRED_PRODUCT_CATEGORY_KEYS,
    ...getProductCategoryKeys(dictionaryProducts),
    ...ibProductKeys,
  ]);
};
